import React from 'react';
import {
  Grid,
  Switch,
  TextField,
  FormHelperText,
  Divider
} from '@material-ui/core';
import JoditEditor from 'jodit-react';


const editorConfig: unknown = {
  'minHeight': 100,
  'showXPathInStatusbar': false,
  'spellcheck': false,
  'askBeforePasteHTML': false,
  'askBeforePasteFromWord': false,
  'toolbar': false,
  'showCharsCounter': false,
  'showWordsCounter': false,
  'enter': 'BR',
  'placeholder': 'Page description'
};

const GalleryGeneral = ({values, onChange}) => {
  const { general } = values;

  return (
    <div>
      <Grid container spacing={3} className="mb-4">
        <Grid item xs={12} sm={2} className="my-2 ml-4">Enable</Grid>
        <Grid item xs={12} sm={9}>
          <Switch
            color="primary"
            checked={general.enabled == 1}
            onChange={(event) => onChange('general.enabled', event.target.checked ? 1 : 0)}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="my-2 ml-4">URL Key</Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            className="w-full max-w-450"
            variant="outlined"
            size="small"
            value={general.url_key}
            onChange={(event) => onChange('general.url_key', event.target.value)}
          />
          <FormHelperText>
            The gallery page address, e.g. &quot;before-after&quot;
          </FormHelperText>
        </Grid>
        <Grid item xs={12} sm={2} className="my-2 ml-4">Page Title</Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            className="w-full max-w-450"
            variant="outlined"
            size="small"
            value={general.page_title}
            onChange={(event) => onChange('general.page_title', event.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="my-2 ml-4">Description</Grid>
        <Grid item xs={12} sm={9}>
          <JoditEditor
            value={general.description}
            config={editorConfig}
            onChange={(newContent) => onChange('general.description', newContent.replace(/style="(.*?)"/gm, ''))}
            onBlur={(newContent) => onChange('general.description', newContent.replace(/style="(.*?)"/gm, ''))}
          />
          <FormHelperText>
            Displayed above the gallery, e.g. a nudity warning or copyright notice
          </FormHelperText>
        </Grid>
      </Grid>
      <Divider className="my-8" />
      <Grid container spacing={3} className="mb-4">
        <Grid item xs={12} sm={2} className="my-2 ml-4">Meta Title</Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            className="w-full max-w-450"
            variant="outlined"
            size="small"
            value={general.meta_title}
            onChange={(event) => onChange('general.meta_title', event.target.value)}
          />
          <FormHelperText>
            Leave empty to use the Page Title
          </FormHelperText>
        </Grid>
        <Grid item xs={12} sm={2} className="my-2 ml-4">Meta Description</Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            className="w-full max-w-450"
            variant="outlined"
            size="small"
            multiline
            minRows={2}
            value={general.meta_description}
            onChange={(event) => onChange('general.meta_description', event.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="my-2 ml-4">Meta Keywords</Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            className="w-full max-w-450"
            variant="outlined"
            size="small"
            value={general.meta_keywords}
            onChange={(event) => onChange('general.meta_keywords', event.target.value)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default GalleryGeneral;
